import React from 'react';

export const feeManagementRouteConfig = [
  {
    routes: [
      {
        path: '/feeManagement',
        component: React.lazy(() => import('./FeeManagement')),
      },
    ],
  },
];
